'use client'
import { isUnavailableVoucher } from '@/features/help/utils/helper'
import { useCartStore } from '@/store'
import { useVoucherStore } from '@/store/voucher'
import { useEffect } from 'react'
import { IListPromotion, IListPromotionItem } from '../types'
type Props = {
  data?:
    | {
        status: string
        data: Omit<IListPromotion, 'total_count' | 'grand_total' | 'single_price'> | null
        message: string
      }
    | undefined
  isLoading: boolean
}
export const useHandleVoucher = ({ data, isLoading }: Props) => {
  const { cartData } = useCartStore()
  const { setListVoucher, setLoading, syncActiveVoucher, setDataCartPriceRule } = useVoucherStore()

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading, setLoading])

  useEffect(() => {
    if (!data || !data?.data) return
    setDataCartPriceRule(data?.data as unknown as IListPromotion)
  }, [data, setDataCartPriceRule])

  // Sync active voucher khi có data và cartData
  useEffect(() => {
    if (!data) return
    const activeCodeFromCart = cartData?.applied_coupons?.[0]?.code?.split(',') || []
    const theActiveVouchers =
      data?.data?.items?.filter((item: IListPromotionItem) => {
        if (!item?.code) {
          return item?.is_applied
        }
        return activeCodeFromCart?.includes(item?.code)
      }) || []
    const filteredVouchers = data?.data?.items?.filter((item) => !isUnavailableVoucher(item)) || []
    const isCheckAll = theActiveVouchers?.length === filteredVouchers?.length
    syncActiveVoucher(theActiveVouchers, isCheckAll)
  }, [cartData?.applied_coupons, data, syncActiveVoucher])

  useEffect(() => {
    if (isLoading) return
    if (data?.status == 'error') return
    if (!data?.data) return

    setListVoucher(data?.data?.items || [])
  }, [data, isLoading, setListVoucher])
}
